// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import {
    Table,
    Col,
    Row,
    UncontrolledTooltip,
} from "reactstrap"

//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import DeleteModal from "components/_Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";

// actions
import { deleteSchorHorizontalText, listSchorHorizontalText } from "store/actions";
import TextAddEditModal from "../AddEdit/TextAddEditModal ";
import toastr from "toastr";
import MyPagination from "components/_Common/MyPagination";
import { MdArrowBackIos } from "react-icons/md";
import { withTranslation } from "react-i18next";


const TextList = props => {
    //meta title
    document.title = `${props.t("Schor Horizontal Text")} | ${props.t("Admin")}`;

    const { error, success, loading } = useSelector(state => ({
        loading: state.SchorHorizontal.loading,
        error: state.SchorHorizontal.error,
        success: state.SchorHorizontal.success,
    }));

    const dispatch = useDispatch();
    const { state } = useLocation();
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [itemData, SetItemData] = useState();
    const [tableData, SetTableData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)
    const [filterData, setFilterData] = useState({
        "limit": 25,
        "page": currentPage,
        "search": "",
    });

    const toggle = () => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    };

    //delete question
    const [deleteModal, setDeleteModal] = useState(false);
    const onClickDelete = (item) => {
        SetItemData(item)
        setDeleteModal(true);
    };
    const handleDeleteSchorHorizontalText = () => {
        dispatch(deleteSchorHorizontalText({ ids: [itemData?.id] }, (res) => {
            if (res?.status === 'success') {
                setDeleteModal(false);
                toastr.success(res?.message)
                fetchSchorHorizontalTextList(filterData)
                setFilterData(prevFilterData => ({
                    ...prevFilterData,
                    randomEvent: Math.random()
                }));

            } else {
                toastr.error(res?.message)
            }
        }))
    };

    // edit 
    const handleQuestionClick = data => {
        setIsEdit(true);
        SetItemData(data)
        toggle();
    };

    // list
    const fetchSchorHorizontalTextList = (filterData) => {
        dispatch(listSchorHorizontalText(filterData, state?.horizontalSchorData?.id, (res) => {
            if (res?.status === 'success') {
                SetTableData(res?.data)
                SetItemData({})
            }
        }))
    }
    useEffect(() => {
        fetchSchorHorizontalTextList(filterData)
    }, [currentPage, filterData?.search, filterData?.limit, filterData?.question_type])

    // filter 
    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    // Function to handle search
    const handleSearch = debounce((searchTerm) => {
        setFilterData(prevFilterData => ({
            ...prevFilterData,
            search: searchTerm
        }));
    }, 500);

    const handleLimit = (val) => {
        setFilterData(prevFilterData => ({
            ...prevFilterData,
            limit: val
        }));
    }

    // delete selecetd
    const [deleteIds, setDeleteIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const toggleSelectAll = () => {
        setSelectAll(!selectAll);
        const ids = selectAll ? [] : tableData?.horizontal?.map(item => item.id);
        setDeleteIds(ids || []);
    };

    const onChangeSelectDelete = (id) => {
        const updatedDeleteIds = deleteIds.includes(id)
            ? deleteIds.filter(deleteId => deleteId !== id)
            : [...deleteIds, id];
        setDeleteIds(updatedDeleteIds);
    }

    const onDeleteSelected = () => {
        dispatch(deleteSchorHorizontalText({ ids: [...deleteIds] }, (res) => {
            if (res?.status === 'success') {
                setDeleteModal(false);
                toastr.success(res?.message)
                fetchSchorHorizontalTextList(filterData)
                setFilterData(prevFilterData => ({
                    ...prevFilterData,
                    randomEvent: Math.random()
                }));
                setDeleteIds([]);
                setSelectAll(false);
                setMultiDeleteModal(false);

            } else {
                toastr.error(res?.message);
                setMultiDeleteModal(false);

            }
        }))
    };

    const extractFirstLine = (htmlContent) => {
        // Remove HTML tags from content
        const plainText = htmlContent.replace(/<[^>]+>/g, '');
        // Split text into words
        const words = plainText.split(/\s+/);
        // Extract first 50 words
        const first50Words = words.slice(0, 50).join(' ');
        return first50Words;
    };

    const [multiDeleteModal, setMultiDeleteModal] = useState(false);
    const onClickMultiDelete = () => {
        setMultiDeleteModal(true);
    };


    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteSchorHorizontalText}
                onCloseClick={() => setDeleteModal(false)}
                loading={loading}
                modalContent={props.t("Are you sure delete Schor Text ?")}
            />
            <DeleteModal
                show={multiDeleteModal}
                onDeleteClick={onDeleteSelected}
                onCloseClick={() => setMultiDeleteModal(false)}
                loading={loading}
                modalContent="Are you sure delete Question?"
            />
            <TextAddEditModal
                modal={modal}
                toggle={toggle}
                isEdit={isEdit}
                itemData={itemData}
                fetchSchorHorizontalTextListData={() => fetchSchorHorizontalTextList(filterData)}
                tableData={tableData}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <div className="text-icon-back">
                        <MdArrowBackIos style={{ cursor: "pointer" }} onClick={() => navigate(-1)} /> <Breadcrumbs isBack='yes' title={props.t("Aspirations")} breadcrumbItem={props.t("Schor Horizontal")} breadcrumbItemText={props.t("Schor Horizontal Text")} />
                    </div>
                    <Row>
                        <Col lg="12">
                            <Row className="mb-2 d-flex show-select justify-spacebetween">
                                <Col md={1} className="me-4 space-marg-rem" >
                                    <select
                                        className="form-select custm-select"
                                        onChange={(e) => handleLimit(e.target.value)}
                                    >
                                        <option value="25">
                                            {props.t("Show")} 25
                                        </option>
                                        <option value="50">
                                            {props.t("Show")} 50
                                        </option>
                                        <option value="75">
                                            {props.t("Show")} 75
                                        </option>
                                        <option value="100">
                                            {props.t("Show")} 100
                                        </option>
                                    </select>
                                </Col>
                                <Col md={2}>
                                    <div className="search-box d-inline-block">
                                        <div className="position-relative">
                                            <label htmlFor="search-bar-0" className="search-label">
                                                <input
                                                    onChange={e => {
                                                        handleSearch(e.target.value);
                                                    }}
                                                    id="search-bar-0"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={props.t("Search") + "..."}
                                                />
                                            </label>
                                            <i className="bx bx-search-alt search-icon"></i>
                                        </div>
                                    </div>

                                </Col>
                                <Col md={4}></Col>
                                <Col md={4} className="text-end pe-0">

                                    <div className="custm-btns">
                                        {
                                            deleteIds?.length > 0 &&
                                            <button
                                                disabled={deleteIds?.length <= 0 ? true : false}
                                                className="btn btn-lg btn-soft-danger"
                                                onClick={onClickMultiDelete}
                                                style={{ background: deleteIds?.length <= 0 ? "#82345573" : "", color: deleteIds?.length <= 0 ? "white" : "" }}
                                            >
                                                {props.t("Delete Selected")}

                                            </button>
                                        }

                                        <button
                                            onClick={() => {
                                                setModal(true)
                                                setIsEdit(false)
                                                SetItemData({})

                                            }}
                                            className="btn btn-primary"
                                        >
                                            {props.t("Add Horizontal Text")}
                                        </button>
                                        {/* <Link onClick={() => fetchQuestionList(filterData)} className="btn btn-light me-1"><i className="mdi mdi-refresh"></i></Link> */}
                                    </div>
                                </Col>
                            </Row>
                            <div className="table-responsive">
                                {
                                    loading ?
                                        <div className="loader d-flex justify-content-center align-items-center mt-5" >
                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                            {props.t("Loading")}
                                        </div>
                                        :
                                        <Table className="table mb-0">
                                            <thead>
                                                <tr>

                                                    {/* <th>#</th> */}
                                                    <th style={{width: '0px'}}>
                                                        <label className="radio-check-label">
                                                            <input
                                                                className="fill-checkbox"
                                                                type="checkbox"
                                                                checked={selectAll}
                                                                onClick={toggleSelectAll}
                                                                onChange={toggleSelectAll}
                                                            />
                                                            <span className="radio-check"></span>
                                                        </label>
                                                    </th>
                                                    <th className="main-data-fix-width">{props.t("Schor Text")}</th>
                                                    <th>{props.t("Language")}</th>
                                                    <th>{props.t("Status")}</th>
                                                    <th style={{ textAlign: "center", paddingRight: "25px" }}>{props.t("Action")}</th>
                                                </tr>
                                            </thead>
                                            {
                                                tableData?.horizontal?.length <= 0
                                                    ?
                                                    <tr>
                                                        <td colSpan="5" className="text-center no-record-found">{props.t("No Record Found")}</td>
                                                    </tr>
                                                    :
                                                    <tbody>
                                                        {(tableData?.horizontal || []).map((item, index) => (
                                                            <tr key={index}>

                                                                {/* <td scope="row" className="drag-pointer">{item.id}</td> */}
                                                                <td>
                                                                    <label className="radio-check-label">
                                                                        <input
                                                                            className="fill-checkbox"
                                                                            type="checkbox"
                                                                            onChange={toggleSelectAll}
                                                                            checked={deleteIds.includes(item.id)}
                                                                            onClick={() => onChangeSelectDelete(item.id)}
                                                                        />
                                                                        <span className="radio-check"></span>
                                                                    </label>
                                                                </td>
                                                                <td className="txt-manage" dangerouslySetInnerHTML={{ __html: extractFirstLine(item?.text) }} />
                                                                <td>{item?.languageName}</td>
                                                                <td><button className={item?.is_active === 'Y' ? "yes-btn" : "no-btn"}> {item?.is_active === 'Y' ? "Active" : "In-Active"}</button></td>
                                                                <td>
                                                                    <ul className="list-unstyled hstack gap-1 mb-0">
                                                                        <li>
                                                                            <span
                                                                                className="btn btn-sm btn-soft-info"
                                                                                onClick={() => {
                                                                                    handleQuestionClick(item);
                                                                                }}
                                                                            >
                                                                                <i className="bx bx-edit" id={`edittooltip${item?.id}`} />
                                                                                <UncontrolledTooltip placement="top" target={`edittooltip${item?.id}`}>
                                                                                    {props.t("Edit")}
                                                                                </UncontrolledTooltip>
                                                                            </span>
                                                                        </li>

                                                                        <li>
                                                                            <span
                                                                                className="btn btn-sm btn-soft-danger"
                                                                                onClick={() => {
                                                                                    onClickDelete(item);
                                                                                }}
                                                                            >
                                                                                <i className="bx bx-trash" id={`deletetooltip${item?.id}`} />
                                                                                <UncontrolledTooltip placement="top" target={`deletetooltip${item?.id}`}>
                                                                                    {props.t("Delete")}
                                                                                </UncontrolledTooltip>
                                                                            </span>
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                            }

                                        </Table>
                                }
                            </div>
                            {
                                tableData?.records < filterData?.limit ?
                                    ""
                                    :
                                    <MyPagination
                                        filterData={filterData}
                                        recordsPerPage={filterData?.limit}
                                        totalRecords={tableData?.records}
                                        currentPage={currentPage}
                                        onPageChange={(pageNumber) => {
                                            setCurrentPage(pageNumber)
                                            setFilterData(prevFilterData => ({
                                                ...prevFilterData,
                                                page: pageNumber
                                            }));
                                        }}
                                    />
                            }
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}


TextList.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};
export default withTranslation()(TextList);

